// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cu0RB","col":"styles_col__3ei9r"};